var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"customer-support-action",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.zendesk_open_chat({ cta_id: _vm.cta_id })}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }